import { InputLabel } from "@material-ui/core";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { SelectProps } from "./Select.type";

const INPUT_COLOR_ERROR = "red";
const INPUT_COLOR = "#D0D0D0";
const ML = "10px"

export default function Select({
  fieldName,
  label,
  options,
  register,
  required,
  error,
  onChange,
  styles,
  readOnly,
  disableFirstOption,
  defaultValue = "",
  disabled = false,
}: SelectProps) {
  const [defaultVal, setDefaultVal] = useState(defaultValue);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    setDefaultVal(defaultValue);
  }, [defaultValue, searchParams]);

  return (
    <>
      <select
        disabled={readOnly || disabled}
        className={styles}
        value={defaultVal}
        {...register(fieldName, {
          required,
          onChange: (e) => {
            setDefaultVal(e.target.value);
            onChange && onChange(e);
          },
        })}
        style={{
          borderColor: `${error ? INPUT_COLOR_ERROR : INPUT_COLOR}`,
        }}
      >
        {!disableFirstOption && (
          <option value="" disabled>
            {label}
          </option>
        )}
        {options?.map((option, index) => (
          <option key={`${option.value}-${index}`} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>
      {/* ERRORS MESSAGE */}
      {error?.message && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
      )}
      {error?.type === "required" && (
        <span style={{ color: INPUT_COLOR_ERROR, marginLeft:ML }}>
          Seleccionar opción válida*
        </span>
      )}
    </>
  );
}
